import monkeyServerAxios from "./../common-util/monkeyServerAxios";
import {
  CHANGE_LANGUAGE_TEMP,
  DESTROY_USER_SETTINGS,
  RETRIEVE_LOAD_USER_INFO,
  SELL_AVATAR,
  SIGN_IN,
  SIGN_OUT,
  UPDATE_USER_RECORDS,
  UPDATE_USER_SETTINGS,
} from "./types";
import getIdToken from "./../common-util/getIdToken";
import getUserId from "./../common-util/gerUserId";

/** user login */
export const signIn = (userInfo) => {
  return {
    type: SIGN_IN,
    payload: userInfo
  };
};

export const signOut = () => {
  return {
    type: SIGN_OUT
  };
};

/** user settings */
export const updateUserSettings = (userSettings) => {
  return {
    type: UPDATE_USER_SETTINGS,
    payload: userSettings  //user setting will be json read and organized from database
  };
}

export const retrieveAndUpdateUserInformation = (userId, idToken, tokenSource) =>  async dispatch => {
  // request user settings from database, and then send data and status code to redux store
  monkeyServerAxios({
      method: "post",
      url: "/user_records/settings/",
      data: { userId, idToken, tokenSource }
  }).then((response) => {
    const userInformationFromDB = { status: response.status, data: response.data };
    dispatch({ type: RETRIEVE_LOAD_USER_INFO, payload: userInformationFromDB});
  }).catch(
    (error) => {
      // https://www.npmjs.com/package/axios#handling-errors
      if (error.response) {
        const userInformationFromDB = { status: error.response.status, data: error.response.data };
        dispatch({ type: RETRIEVE_LOAD_USER_INFO, payload: userInformationFromDB});
      } else {
        const userInformationFromDB = { status: 600, data: {message: "Net work error. Try again later."} };
        dispatch({ type: RETRIEVE_LOAD_USER_INFO, payload: userInformationFromDB});
      }
    }
  );
}

export const setAvatarInDB = (avatarId, tokenSource="google") =>  async dispatch => {
  // update avatar in db, get data from database, and then send data and status code to redux store
  const userId = getUserId();
  const idToken = getIdToken();
  console.log(userId, idToken);
  monkeyServerAxios({
      method: "post",
      url: "/user_records/set_avatar/",
      data: { userId, idToken, tokenSource, avatarId }
  }).then((response) => {
    const userInformationFromDB = { status: response.status, data: response.data };
    dispatch({ type: RETRIEVE_LOAD_USER_INFO, payload: userInformationFromDB});
  }).catch(
    (error) => {
      // https://www.npmjs.com/package/axios#handling-errors
      if (error.response) {
        const userInformationFromDB = { status: error.response.status, data: error.response.data };
        dispatch({ type: RETRIEVE_LOAD_USER_INFO, payload: userInformationFromDB});
      } else {
        const userInformationFromDB = { status: 600, data: {message: "Net work error. Try again later."} };
        dispatch({ type: RETRIEVE_LOAD_USER_INFO, payload: userInformationFromDB});
      }
    }
  );
}

export const setUserSettingsInDB = (userSettings, tokenSource="google") =>  async dispatch => {
  // update user settings in database, and then send response data and status code to redux store
  const userId = getUserId();
  const idToken = getIdToken();
  const data = { userId, idToken, tokenSource, ...userSettings };

  monkeyServerAxios({
      method: "post",
      url: "/user_records/settings/",
      data: data
  }).then((response) => {
    const userInformationFromDB = { status: response.status, data: response.data };
    dispatch({ type: RETRIEVE_LOAD_USER_INFO, payload: userInformationFromDB});
  }).catch(
    (error) => {
      // https://www.npmjs.com/package/axios#handling-errors
      if (error.response) {
        const userInformationFromDB = { status: error.response.status, data: error.response.data };
        dispatch({ type: RETRIEVE_LOAD_USER_INFO, payload: userInformationFromDB});
      } else {
        const userInformationFromDB = { status: 600, data: {message: "Net work error. Try again later."} };
        dispatch({ type: RETRIEVE_LOAD_USER_INFO, payload: userInformationFromDB});
      }
    }
  );
}

export const updateMathRecordsInDB = (records, tokenSource="google") =>  async dispatch => {
  // update records in database, and then send response data and status code to redux store
  const userId = getUserId();
  const idToken = getIdToken();
  const data = { userId, idToken, tokenSource, ...records};

  monkeyServerAxios({
      method: "post",
      url: "/user_records/update_math/",
      data: data
  }).then((response) => {
    const userInformationFromDB = { status: response.status, data: response.data };
    dispatch({ type: RETRIEVE_LOAD_USER_INFO, payload: userInformationFromDB});
  }).catch(
    (error) => {
      // https://www.npmjs.com/package/axios#handling-errors
      if (error.response) {
        const userInformationFromDB = { status: error.response.status, data: error.response.data };
        dispatch({ type: RETRIEVE_LOAD_USER_INFO, payload: userInformationFromDB});
      } else {
        const userInformationFromDB = { status: 600, data: {message: "Net work error. Try again later."} };
        dispatch({ type: RETRIEVE_LOAD_USER_INFO, payload: userInformationFromDB});
      }
    }
  );
}

export const destroyUserSettings = () => {
  return {
    type: DESTROY_USER_SETTINGS
  };
}

export const changeLanguage = (language) => {
  return  {
    type: CHANGE_LANGUAGE_TEMP,
    payload: language
  }
}

/** user records */
export const sellAvatar = (avatarInfo) => {
  return {
    type: SELL_AVATAR, 
    payload: avatarInfo // id of the avatar, number of avatar to sell, price for each unit { id, copies, unitPrice}
  }
}

export const updateUserRecords = (records) => {
  return {
    type: UPDATE_USER_RECORDS,
    payload: records // possibly the records from http request
  }
}